import { StudentTotalDebt } from 'src/pages/employees/BranchStudentTotalDebtsPage';
import { StudentDebt } from 'src/pages/employees/BranchStudentDebtsPage';
import { baseApi, QueryPayload } from 'src/api';

const moduleApi = baseApi.injectEndpoints({
    endpoints: builder => ({
        getBranchDebts: builder.query<
            StudentTotalDebt[],
            {
                params: {
                    branchId: number;
                };
            }
        >({
            providesTags: [{ type: 'BranchDebts', id: 'LIST' }],
            query: ({ params }) => ({
                url: `/branches/${params.branchId}/students/debts`,
                method: 'GET',
            }),
        }),
        getBranchStudentDebts: builder.query<
            StudentDebt[],
            {
                params: { branchId: number; studentId: number };
            }
        >({
            providesTags: (_r, _e, { params }) => [
                { type: 'StudentDebts', id: params.studentId },
            ],
            query: ({ params }): QueryPayload => ({
                url: `/branches/${params.branchId}/students/${params.studentId}/debts`,
                method: 'GET',
            }),
        }),

        registerBranchStudentDebt: builder.mutation<
            void,
            {
                params: { branchId: number; studentId: number };
                body: {
                    amount: number;
                    description: string;
                    originatedAt: number;
                };
            }
        >({
            invalidatesTags: (_r, _e, { params }) => [
                { type: 'StudentDebts', id: params.studentId },
                'BranchDebts',
            ],
            query: ({ params, body }): QueryPayload => ({
                url: `/branches/${params.branchId}/students/${params.studentId}/debts`,
                method: 'POST',
                data: body,
            }),
        }),

        updateBranchStudentDebt: builder.mutation<
            void,
            {
                params: {
                    branchId: number;
                    studentId: number;
                    debtId: number;
                };
                body: {
                    amount: number | null;
                    description: string | null;
                    originatedAt: number | null;
                };
            }
        >({
            invalidatesTags: (_r, _e, { params }) => [
                { type: 'StudentDebts', id: params.studentId },
                'BranchDebts',
            ],
            query: ({ params, body }): QueryPayload => ({
                url: `/branches/${params.branchId}/students/${params.studentId}/debts/${params.debtId}`,
                method: 'PATCH',
                data: body,
            }),
        }),

        cancelBranchStudentDebt: builder.mutation<
            void,
            {
                params: {
                    branchId: number;
                    studentId: number;
                    debtId: number;
                };
            }
        >({
            invalidatesTags: (_r, _e, { params }) => [
                { type: 'StudentDebts', id: params.studentId },
                'BranchDebts',
            ],
            query: ({ params }): QueryPayload => ({
                url: `/branches/${params.branchId}/students/${params.studentId}/debts/${params.debtId}/cancel`,
                method: 'POST',
            }),
        }),

        registerBranchStudentDebtPayment: builder.mutation<
            void,
            {
                params: {
                    branchId: number;
                    studentId: number;
                    debtId: number;
                };
                body: {
                    paidAt: number;
                };
            }
        >({
            invalidatesTags: (_r, _e, { params }) => [
                { type: 'StudentDebts', id: params.studentId },
                'BranchDebts',
            ],
            query: ({ params, body }): QueryPayload => ({
                url: `/branches/${params.branchId}/students/${params.studentId}/debts/${params.debtId}/paid`,
                method: 'POST',
                data: body,
            }),
        }),
    }),
});

export const {
    useGetBranchDebtsQuery,
    useGetBranchStudentDebtsQuery,
    useRegisterBranchStudentDebtMutation,
    useUpdateBranchStudentDebtMutation,
    useCancelBranchStudentDebtMutation,
    useRegisterBranchStudentDebtPaymentMutation,
} = moduleApi;
